import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
const BaseTableAutoResizer = forwardRef((props, ref) => {
    // Get a ts issue with ForwaredRef
    const { children, width: initialWidth, height: initialHeight, loading } = props;
    const [width, setWidth] = useState(initialWidth || 0);
    const [height, setHeight] = useState(initialHeight || 0);
    const syncWithParentSize = () => {
        if (!(ref === null || ref === void 0 ? void 0 : ref.current))
            return;
        setWidth(initialWidth !== undefined ? initialWidth : ref === null || ref === void 0 ? void 0 : ref.current.offsetWidth);
        setHeight(initialHeight !== undefined ? initialHeight : ref === null || ref === void 0 ? void 0 : ref.current.offsetHeight);
    };
    useEffect(() => {
        syncWithParentSize();
    }, [ref, initialWidth, initialHeight, loading]);
    useEffect(() => {
        const onSizeChange = () => {
            // Timeout to make sure everything rendered
            setTimeout(() => {
                syncWithParentSize();
            }, 100);
        };
        window.addEventListener("resize", onSizeChange);
        return () => window.removeEventListener("resize", onSizeChange);
    }, [initialHeight, initialWidth, loading]);
    return _jsx(_Fragment, { children: children({ width, height }) });
});
export default BaseTableAutoResizer;
